import React, { useState } from "react";
import { formatCurrency } from "../../../utils/helpers";

const Form = ({ tipo, errors }) => {
    const [state, setState] = useState({
        sueldo: tipo.sueldoFijo || 0,
        descuento: tipo.descuento || 0,
        sueldos: tipo.sueldos || []
    });

    function onChangeSueldo(value) {
        setState({
            ...state,
            sueldo: value,
            descuento: value * 0.0591
        });
    }

    function onChangeInput(nombre, value) {
        setState({
            ...state,
            [nombre]: value
        });
    }

    function addSueldo() {
        setState(prev => ({
            ...prev,
            sueldos: [...prev.sueldos, {}],
        }));
    }

    function removeSueldo(index) {
        setState(prev => ({
            ...prev,
            sueldos: prev.sueldos.filter((s, i) => i !== index),
        }));
    }

    const {sueldo, sueldos, descuento} = state;

    return (
        <div className="row">
            <div className="col-md-12">
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>Nombre:</label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={tipo.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>Tipo:</label>
                    </div>
                    <div className='col-md-7'>
                        <select
                            className='text-input form-control'
                            id='tipo_nomina'
                            name='tipo_nomina'
                            defaultValue={tipo.tipoNomina}>
                            <option>Seleccionar</option>
                            <option value='fijo'>Sueldo Fijo</option>
                            <option value='produccion'>Producción</option>
                            <option value='fijo-produccion'>Sueldo Fijo + Producción</option>
                        </select>
                        {errors.tipo_nomina && (
                            <small className='help-blockParams form-Text'>
                                {errors.tipo_nomina[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>Período Nómina:</label>
                    </div>
                    <div className='col-md-7'>
                        <select
                            className='text-input form-control'
                            id='intervalo_nomina'
                            name='intervalo_nomina'
                            defaultValue={tipo.intervaloNomina}>
                            <option>Seleccionar</option>
                            <option value='semanal'>Semanal</option>
                            <option value='quincenal'>Quincenal</option>
                            <option value='mensual'>Mensual</option>
                        </select>
                        {errors.intervalo_nomina && (
                            <small className='help-blockParams form-Text'>
                                {errors.intervalo_nomina[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Opera Vehículos:
                        </label>
                    </div>
                        <div className='col col-md-7'>
                            <input
                                type='checkbox'
                                name='opera_vehiculo'
                                id="opera_vehiculo"
                                defaultChecked={tipo.operaVehiculo === 1}
                                value='1'
                            />
                        </div>
                </div>
            </div>
            <div className="col-md-12">
                <h3>Sueldo Mensual</h3>
                <div className="row">
                    <div className="col-md-4"><small>Nombre:</small></div>
                    <div className="col-md-3"><small>Sueldo Fijo:</small></div>
                    <div className="col-md-2"><small>TSS + AFP:</small></div>
                    <div className="col-md-2"></div>
                    <div className="col-md-1"></div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <div className="d-flex align-items-center">
                            <span>1.</span>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='nombre_sueldo'
                                name='nombre_sueldo'
                                defaultValue={tipo.nombreSueldo}
                            />
                        </div>
                        {errors.nombre_sueldo && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                    <div className='col col-md-3'>
                        <input
                            type='number'
                            step='0.01'
                            className='text-input form-control'
                            id='sueldo_fijo'
                            name='sueldo_fijo'
                            onChange={e => onChangeSueldo(e.target.value)}
                            defaultValue="Predeterminado"
                            value={sueldo}
                        />
                        {errors.sueldoFijo && (
                            <small className='help-blockParams form-Text'>
                                {errors.sueldoFijo[0]}
                            </small>
                        )}
                    </div>
                    <div className='col col-md-2'>
                        <input
                            type='number'
                            className='text-input form-control'
                            id='descuento'
                            name='descuento'
                            step='0.01'
                            onChange={e => onChangeInput('descuento', e.target.value)}
                            value={descuento}
                        />
                        {errors.descuento && (
                            <small className='help-blockParams form-Text'>
                                {errors.descuento[0]}
                            </small>
                        )}
                    </div>
                    <div className="col-md-2" style={{lineHeight: '1'}}>
                        <div><small>AFP 2.87%: {formatCurrency(sueldo * 0.0287)}</small></div>
                        <div><small>TSS 3.04%: {formatCurrency(sueldo * 0.0304)}</small></div>
                    </div>
                    <div className="col-md-1">

                    </div>
                </div>
                {sueldos.length > 0 ? sueldos.map((item, index) => (
                    <SueldoItem
                        key={index}
                        item={item}
                        index={index}
                        errors={errors}
                        removeSueldo={removeSueldo}
                    />
                )) : (
                    <input type="hidden" name="sueldos" value="" />
                )}
                <div className="text-right">
                    <button type="button" onClick={addSueldo}><i className="zmdi zmdi-plus mr-2"></i>Agregar</button>
                </div>
            </div>
        </div>
    );
};

const SueldoItem = ({item, index, removeSueldo, errors}) => {
    const [sueldo, setSueldo] = useState(item.sueldo_fijo || 0);
    const [descuento, setDescuento] = useState(item.descuento || 0);

    function onChangeSueldo(value) {
        setSueldo(value);
        setDescuento(value * 0.0591);
    }

    return (
        <>
            <hr />
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <input type="hidden" name={`sueldos[${index}][id]`} value={index+2} />
                    <div className="d-flex align-items-center">
                        <span>{index + 2}.</span>
                        <input
                            type='text'
                            className='text-input form-control'
                            id={`sueldos[${index}][nombre]`}
                            name={`sueldos[${index}][nombre]`}
                            defaultValue={item.nombre}
                        />
                    </div>
                    {errors?.sueldos && (
                        <small className='help-blockParams form-Text'>
                            {errors.sueldos[index].nombre[0]}
                        </small>
                    )}
                </div>
                <div className='col col-md-3'>
                    <input
                        type='number'
                        step='0.01'
                        className='text-input form-control'
                        id={`sueldos[${index}][sueldo_fijo]`}
                        name={`sueldos[${index}][sueldo_fijo]`}
                        onChange={e => onChangeSueldo(e.target.value)}
                        value={sueldo}
                    />
                    {errors?.sueldos && (
                        <small className='help-blockParams form-Text'>
                            {errors.sueldos[index]?.sueldo_fijo[0]}
                        </small>
                    )}
                </div>
                <div className='col col-md-2'>
                    <input
                        type='number'
                        className='text-input form-control'
                        id={`sueldos[${index}][descuento]`}
                        name={`sueldos[${index}][descuento]`}
                        step='0.01'
                        onChange={e => setDescuento(e.target.value)}
                        value={descuento}
                    />
                    {errors?.sueldos && (
                        <small className='help-blockParams form-Text'>
                            {errors.sueldos[index]?.descuento[0]}
                        </small>
                    )}
                </div>
                <div className="col-md-2" style={{lineHeight: '1'}}>
                    <div><small>AFP 2.87%: {formatCurrency(sueldo * 0.0287)}</small></div>
                    <div><small>TSS 3.04%: {formatCurrency(sueldo * 0.0304)}</small></div>
                </div>
                <div className="col-md-1">
                    {!sueldo && (
                        <button type="button" onClick={() => removeSueldo(index)}><i className="zmdi zmdi-delete"></i></button>
                    )}
                </div>
            </div>
        </>
    );
}

export default Form;
